import { CheckStatusContent } from "@/features/check-status";
import { Layout } from "../Layout";

export const CheckStatusPage = () => {
  return (
    <Layout>
      <CheckStatusContent />
    </Layout>
  );
};
